export const pluginPrefix = 'PLUGIN:VII-GIFTCARDS:';
export const ENTER_PAYMENT_DATA = `${pluginPrefix}ENTER_PAYMENT_DATA`;
export const ENTER_PRODUCT_DATA = `${pluginPrefix}ENTER_PRODUCT_DATA`;
export const RESET_PLUGIN_STATE = `${pluginPrefix}RESET_PLUGIN_STATE`;
export const REMOVE_VII_PRODUCT = `${pluginPrefix}REMOVE_VII_PRODUCT`;
export const REMOVE_VII_PAYMENT = `${pluginPrefix}REMOVE_VII_PAYMENT`;
export const ADD_VII_GIFT_CARD_PRODUCT_TO_CACHE = `${pluginPrefix}ADD_VII_GIFT_CARD_PRODUCT_TO_CACHE`;
export const REMOVE_VII_GIFT_CARD_PRODUCT_FROM_CACHE = `${pluginPrefix}REMOVE_VII_GIFT_CARD_PRODUCT_FROM_CACHE`;
